/**
 * PermissionLockDialog
 * Global modal shown when a user clicks a CTA their role doesn't grant
 * access to. Sibling to PlanLockDialog.tsx (same open/payload pattern via
 * permissionLockSlice.ts, mounted once in AdminLayout), but for RBAC denials
 * rather than plan-tier ones — no "Upgrade Plan" CTA, since a role edit (not
 * a plan change) is what would actually fix this.
 */

import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button } from '@mui/material';
import { Block } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '@/store';
import { hidePermissionLock } from '@/store/slices/permissionLockSlice';

const PermissionLockDialog: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { open, payload } = useSelector((state: RootState) => state.permissionLock);

  const handleClose = () => dispatch(hidePermissionLock());

  if (!payload) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: 'center', p: 4 }}>
        <Block sx={{ fontSize: 48, color: 'error.main', mb: 2 }} />
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {payload.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {payload.message}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Button variant="contained" onClick={handleClose}>
            Got it
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PermissionLockDialog;
